
import { Navigation } from '../../components/feature/Navigation';
import { HeroSection } from './components/HeroSection';
import { VPNSection } from './components/VPNSection';
import { FeaturesSection } from './components/FeaturesSection';
import { AboutSection } from './components/AboutSection';
import { ContactSection } from './components/ContactSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navigation />
      <HeroSection />
      <VPNSection />
      <FeaturesSection />
      <AboutSection />
      <ContactSection />
      <FAQSection />
      <Footer />
    </div>
  );
}
